package pl.decks.chartjs.style

import pl.decks.chartjs.model.JSEnum

@Suppress("unused")
sealed class FontWeightChart {
    data class Numbered(val value: Int) : FontWeightChart()
    data class Named(val weight: Weight) : FontWeightChart()

    enum class Weight(override val jsValue: String) : JSEnum {
        Normal("normal"),
        Bold("bold"),
        Lighter("lighter"),
        Bolder("bolder"),
        W900("900"),
    }

    fun toChartJs() : dynamic = when (this) {
        is Numbered -> this.value.toString().asDynamic()
        is Named -> this.weight.toChartJs()
    }

}
